import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles } from './selectStyles';

export default function SelectGender({ callback, width, value, border, usersFilter, placeholder }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '220px', border })
        : makeDarkSelectStyles({ width: width || '220px', border });


    var options = [
        
        {
            label: "Female",
            value: "1"
        },
        {
            label: "Male",
            value: "0"
        },
        {
            label: "Other",
            value: "2"
        }
    ]

    const handleSelect = (e) => {
        callback(e && e.value, "gender")
    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Gender"}
                    isClearable={true}
                    value={options && options.filter(obj => obj.value == value)}
                    menuPortalTarget={usersFilter ? document.body : undefined}
                    menuPosition={usersFilter ? 'fixed' : undefined}
                />
            </div>

        </>
    )
}
